import GenericBuilderPage from '@/components/builder/GenericBuilderPage';
import { scrumBuilderAPI } from '@/lib/api';

export default function ScrumBuilderPage() {
  return (
    <GenericBuilderPage
      api={scrumBuilderAPI}
      branding={{
        kindLabel: 'Scrum Builder',
        title: 'Bouw jouw scrum sessie',
        subtitle: 'Kies een scrum-type om mee te starten. Vervolgens stel je zelf de onderdelen samen.',
        headlinePrefix: 'Bouw jouw ',
        headlineHighlight: 'ideale scrum sessie',
        headlineSuffix: '',
        ctaLabel: 'Start samenstellen',
        successTitle: 'Bedankt!',
        successMessage: 'We hebben je scrum aanvraag goed ontvangen. Een van onze coaches neemt binnen 1-2 werkdagen contact met je op.',
        accent: 'indigo',
        testIdPrefix: 'scrum-builder',
      }}
    />
  );
}
